import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { cdrErr } from "./cdrMeta";
import { CdrAutoCard } from "./CdrAutoCard";
import { CdrRecipients } from "./CdrRecipients";
import { CdrSendHistory } from "./CdrSendHistory";

/** Reports → CDR files: the monthly CDR export to partners and customers (replaces send_cdrs.php). */
export function CdrFilesTab() {
  const [ov, setOv] = useState(null);
  const [histKey, setHistKey] = useState(0);
  const load = useCallback(() => api.get("/cdr-dispatch/overview").then(({ data }) => setOv(data))
    .catch((e) => toast.error(cdrErr(e, "Could not load CDR files"))), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!ov?.running) return undefined;
    const t = setInterval(() => { load(); setHistKey((k) => k + 1); }, 5000);
    return () => clearInterval(t);
  }, [ov?.running, load]);
  if (!ov) return <Loader2 className="mx-auto mt-12 h-6 w-6 animate-spin text-slate-300" />;
  const sent = () => { load(); setHistKey((k) => k + 1); };
  return (
    <div className="space-y-4" data-testid="cdr-files-tab">
      <p className="max-w-3xl text-sm text-slate-500">Each territory or domain on the list gets its calls for the billing cycle as a CSV file, e-mailed on the 1st for the cycle that just closed. Calls come from the billing database that Billing Sync → Usage Charges fills from WebCDR.</p>
      <CdrAutoCard ov={ov} reload={load} />
      <CdrRecipients ov={ov} reload={load} onSent={sent} />
      <CdrSendHistory refreshKey={histKey} />
    </div>
  );
}
